import React from 'react';
import { StyleContext } from './DialogStyleContext';
export const DialogStyleProvider = ({
  children
}) => {
  const topLevelBoxStyle = {
    width: '100%',
    height: 'calc(100% - 133px)',
    style: {
      position: 'absolute',
      top: '65px',
      overflowY: 'scroll',
      overflowX: 'hidden'
    },
    borderBottom: '1px solid #c0cad5'
  };
  const contentFlexStyle = {
    pb: 2,
    px: 3,
    width: '100%',
    minHeight: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  };
  const inputStyle = {
    width: '100%',
    style: {
      position: 'absolute',
      bottom: '0px'
    },
    position: 'absolute',
    bottom: '0px'
  };
  const recordingIndicatorStyle = {
    height: '290px',
    circleHeight: '161px',
    circleWidth: '161px'
  };
  return React.createElement(StyleContext.Provider, {
    value: {
      topLevelBoxStyle,
      contentFlexStyle,
      inputStyle,
      recordingIndicatorStyle
    }
  }, children);
};